import { Injectable } from '@angular/core';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash-es';
import { Permissions } from 'src/app/models/permissions/permissions';
import { ModulesDto } from 'src/app/models/center/modules-dto';
import { Observable } from 'rxjs';
import { StaffLogin } from 'src/app/models/staff/staff-login';
import { Center } from 'src/app/models/center/center';
import { PermissionsFull } from 'src/app/models/permissions/permissions-full';
import { HttpService } from '../http/http.service';

@Injectable({
    providedIn: 'root'
})
export class UserService extends HttpService {
    private TIME_LIVE = 24;

    constructor(private cookieService: CookieService) {
        super();
    }

    setToken(token: string): void {
        this.cookieService.set('token', token);
    }
    getVisitorToken(): Observable<any> {
        const url = 'hubSpot/visitor';

        return this.get(`${url}`, { app: 'center', version: 1 });
    }

    setActiveToken(): void {
        const now = moment().add(this.TIME_LIVE, 'hour');
        this.cookieService.set('timestamp', now.valueOf().toString());
    }

    setPermissions(permissions: Permissions): void {
        localStorage.setItem('permissions', JSON.stringify(permissions));
    }


    getPermissions(): PermissionsFull | null {
        const permissionsString = localStorage.getItem('permissions');
        let permissions: PermissionsFull | null = null;
        if (!_.isEmpty(permissionsString) && permissionsString) {
            permissions = JSON.parse(permissionsString);
        }

        return permissions;
    }

    updatePermissions(permissions: Permissions): void {
        this.setPermissions(permissions);
    }

    getToken(): string {
        return this.cookieService.get('token');
    }

    isActiveToken(): boolean {
        const timestampStorage = this.cookieService.get('timestamp');
        if (!_.isEmpty(timestampStorage)) {
            const now = moment();
            if (timestampStorage) {
                let timestamp = moment(new Date(+timestampStorage));
                if (timestamp.isAfter(now)) {
                    timestamp = now.add(this.TIME_LIVE, 'hour');
                    this.cookieService.set('timestamp', timestamp.valueOf().toString());

                    return true;
                }
            }
        }

        return false;
    }

    setUser(user: unknown): void {
        this.cookieService.set('user', JSON.stringify(user));
    }

    getUserToken(): number {
        // TODO: Revisar esto.
        return this.getUser();
    }

    getUser(): any {
        const user = this.cookieService.get('user');
        if (user) {
            return JSON.parse(user);
        }

        return 0;
    }

    setIdStaff(idStaff: number): void {
        this.cookieService.set('idStaff', idStaff.toString());
    }

    setSettings(settings: any): void {
        this.cookieService.set('settings', settings.toString());
    }

    getIdStaff(): number {
        const idStaff = this.cookieService.get('idStaff');
        if (idStaff) {
            return parseInt(idStaff, 10);
        }

        return -1;
    }

    setCenter(center: unknown): void {
        localStorage.setItem('center', JSON.stringify(center));
    }

    removeCenter(): void {
        localStorage.removeItem('center');
    }

    updateCenter(center: Center): void {
        this.removeCenter();
        this.setCenter(center);
    }

    getCenter(): Center {
        const centers = this.getCenters();
        const selectedCenter = localStorage.getItem('center') ?? '';
        const myCenter = JSON.parse(selectedCenter);
        let completCenter;

        if (centers.length && selectedCenter) {
            centers.forEach(center => {
                if (center.center.id === myCenter.id) {
                    completCenter = center;
                }
            });
        }
        if (completCenter) {
            return completCenter;
        } else {
            return myCenter;
        }
    }
    setCenters(centers: Center[]): void {
        localStorage.setItem('centers', JSON.stringify(centers));
    }

    setCenterModule(centerModule: ModulesDto): void {
        localStorage.setItem('centerModule', JSON.stringify(centerModule));
    }

    getCenterModule(): ModulesDto | undefined {
        const centerModule = localStorage.getItem('centerModule');
        if (centerModule) {
            return JSON.parse(centerModule);
        }

        return undefined;
    }


    getCenters(): Center[] {
        const centers = localStorage.getItem('centers');
        if (centers) {
            return JSON.parse(centers);
        }

        return [];
    }


    isControlCapacityActive(): boolean {
        const data = this.getCenterModule();
        if (data) {
            return data.isControlCapacityActivated;
        }

        return false;
    }

    updatePassword(idStaff: number, password: string): Observable<void> {
        return this.put(`staff/${idStaff}/password`, { app: 'center', version: 1 }, { password, idUser: idStaff });
    }

    updateUsername(username: string): Observable<void> {
        return this.put('nicknames', { app: 'center', version: 1 }, { value: username });
    }

    isUsernameAvailableModified(username: string): Observable<boolean> {
        return this.get(`nicknames/modified?available=${username}`, { app: 'center', version: 1 });
    }

    setStaffData(username: string, password: string, isTemporalPassword: boolean): void {
        const staffData = {
            username,
            password,
            isTemporalPassword
        };
        this.cookieService.set('staffData', JSON.stringify(staffData));
    }

    getStaffData(): StaffLogin | null {
        if (this.cookieService.get('staffData')) {
            return JSON.parse(this.cookieService.get('staffData'));
        }

        return null;
    }
}
